import { LocalStorageCache } from "@auth0/auth0-react";
import { borrarAlgunasCookies, borrarCookies, createCookieByMinutes, readCookie } from "../Helpers/Cookies";
import { ACCESS_TOKEN_EXPIRATION, ID_TOKEN_EXPIRATION, REFRESH_TOKEN_EXPIRATION } from "../Config/Cookies";

const getAuth0Cookies = () => {
    let token = readCookie('token');
    let xvalue = readCookie('xvalue');
    if (token == null && xvalue == null) return null;
    return [token, xvalue]
};

const getAuth0TokensFromCache = () => {
    const refresh_token = new LocalStorageCache;
    const key = refresh_token.allKeys().find(key => key.includes('auth0spa'));
    const refresh_token_value = refresh_token.get(key);
    const tokens = {};
    tokens.finalRefreshToken = refresh_token_value?.body?.refresh_token
    tokens.idToken = refresh_token_value?.body?.id_token
    tokens.userId = refresh_token_value?.body?.decodedToken.claims.sub;
    tokens.accessToken = refresh_token_value?.body?.access_token;
    return tokens;
};

const deleteAuth0Cookies = async () => {
    borrarCookies();
};

const deleteOriginCookie = () => {
    borrarAlgunasCookies(['OriginId']);
};

const getOriginIdCookie = () => {
    const OriginId = readCookie('OriginId');
    return OriginId != null;
}

const setAuth0TokensCookies = (access_token, refresh_token, id_token) => {
    createCookieByMinutes("token", id_token, ID_TOKEN_EXPIRATION);
    createCookieByMinutes("xvalue", refresh_token, REFRESH_TOKEN_EXPIRATION);
    createCookieByMinutes("access-token", access_token, ACCESS_TOKEN_EXPIRATION);
}

export {
    getAuth0Cookies,
    deleteAuth0Cookies,
    getAuth0TokensFromCache,
    getOriginIdCookie,
    setAuth0TokensCookies,
    deleteOriginCookie,
};